//@ts-check

//External
import React, { useState } from "react"
import _ from "lodash"
import Hidden from "@material-ui/core/Hidden"
import { useTranslation } from "react-i18next"
import useStyles from "./styles.js"

//Icons
import ViewComfyIcon from "@material-ui/icons/ViewComfy"
import BugReportIcon from "@material-ui/icons/BugReport"
import SecurityIcon from "@material-ui/icons/Security"
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser"
import EcoIcon from "@material-ui/icons/Eco"

// Internal
import TabbedView from "./tabbed-view"
import OutputTabSelect from "./output-tab-select"
import { track } from "../utils/tracking"
import consts from "shared/consts.js"

// Components
import OutputOneTab from "./output-one-tab"
import { TrashIcon } from "./icons-svg.js"
import { Chip } from "@material-ui/core"

/**
 *@param props {{
   analysisOutput:import("../../../backend/interfaces").TestResultWithTestData[],
   onClickNewCustomText: Function
   customTests: Array
   clickCustomTest: Function
   deleteCustomTest: Function
   scrollToSource: Function
   isShowAllTests?: Boolean
   isShowCategories?: Boolean
  }}
 */
var OutputComponent = ({
  analysisOutput,
  onClickNewCustomText,
  customTests = [],
  clickCustomTest,
  deleteCustomTest,
  scrollToSource,
  isShowAllTests=true,
  isShowCategories=true
}) => {
  const { t } = useTranslation()
  const criteria = {
    overview: {
      title: t("overview"),
      icon: <ViewComfyIcon />,
      description: [t("overview_description")],
      showSubCategories: false,
    },
    // functionality: {
    //   title: t("erc20_functionality"),
    //   icon: <BugReportIcon />,
    //   description: [t("functionality_description")],
    //   showSubCategories: true,
    // },
    security: {
      title: t("security"),
      icon: <SecurityIcon />,
      description: [t("security_description")],
      showSubCategories: false,
    },
    quality: {
      title: t("quality"),
      icon: <VerifiedUserIcon />,
      description: [t("quality_description")],
      showSubCategories: false,
    },
    // efficiency: {
    //   title: t("efficiency"),
    //   icon: <EcoIcon />,
    //   description: [t("efficiency_description")],
    //   showSubCategories: false,
    // },
  }
  if (window["config"]?.SHOW_SWC) {
    criteria["swc"] = {
      title: "SWC",
      icon: <EcoIcon />,
      description: [t("swc_description")],
      showSubCategories: false,
    }
  }
  if (window["config"]?.ENABLE_INTERACTIVE) {
    criteria["my_tests"] = {
      title: "My Tests",
      icon: <EcoIcon />,
      description: t("my_texts_description"),
      showSubCategories: false,
    }
  }

  const classes = useStyles({})
  const resultTypes = Object.keys(criteria)
  const tabNames = resultTypes.map(type => criteria[type].title)
  const [selectedCriterion, setSelectedCriterion] = useState(0)

  const analysisByCategory = {}
  for (const result of analysisOutput) {
    const category = result.category.toLowerCase()
    if (!analysisByCategory[category]) {
      analysisByCategory[category] = []
    }
    if (category === "swc" && !result.swc) continue
    if (
      !isShowAllTests && (
        (window?.config?.["EXPERIMENTAL_ONLY"] && !result.experimental) || 
        (!window?.config?.["EXPERIMENTAL_ONLY"] && result.experimental)
      )
    ) continue
    analysisByCategory[category].push(result)
  }
  const criterionKey = resultTypes[selectedCriterion]

  const generateTabList = ({ resultTypes, analysisOutput, criteria, criterionKey, results }) => {
    if (criterionKey == "my_tests") {
      return (
        <div>
          <br />
          <br />
          {customTests.map((ct, index) => (
            <div
              css={`
                clear: both;
                margin-top: 4px;
                padding-top: 10px;
                border-bottom: 1px solid rgba(196, 196, 205, 0.35);
                padding-bottom: 10px;
                padding-left: 5px;
                :hover {
                  /* box-sizing: border-box; */
                  border: 1px solid #2e2e38;
                  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2),
                    0 2px 2px 0 rgba(0, 0, 0, 0.14),
                    0 1px 5px 0 rgba(0, 0, 0, 0.12);
                }
                :hover .a {
                  display: block;
                }
              `}
            >
              <div
                className="a"
                css={`
                  display: none;
                  float: right;
                `}
              >
                <div
                  css={`
                    font-weight: 600;
                    font-size: 18;
                    opacity: 0.8;
                    padding: 25;
                    cursor: pointer;
                    border: 1px solid black;
                    display: inline-block;
                    padding: 10px 20px;
                    font-weight: 600;
                  `}
                  onClick={clickCustomTest.bind(null, index)}
                >
                  &nbsp; Open in Test Studio
                </div>
                &nbsp;&nbsp;
                <div
                  css={`
                    font-weight: 600;
                    font-size: 18;
                    /* min-heigh
                     */
                    opacity: 0.8;
                    padding: 25;
                    cursor: pointer;
                    border: 1px solid black;
                    display: inline-block;
                    padding: 10px 20px;
                    font-weight: 600;
                  `}
                  onClick={deleteCustomTest.bind(null, index)}
                >
                  {TrashIcon}
                  &nbsp; Delete
                </div>
                &nbsp;&nbsp;
              </div>
              <span
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                }}
                onClick={clickCustomTest.bind(null, index)}
              >
                {ct.name}
              </span>
              <br />
              <Chip
                type="error"
                label="Custom test"
                style={{ background: "#155CB4", color: "#F6F6FA" }}
              />
              <span
                style={{
                  fontSize: 14,
                  color: "#2E2E38",
                }}
              >
                &nbsp; ({ct.steps.length} steps)
              </span>
            </div>
          ))}
          <br />
          <div
            onClick={onClickNewCustomText}
            css={`
              /* text-align: center; */
              font-size: 18;
              opacity: 0.8;
              padding: 25;
              cursor: pointer;
              border: 1px solid black;
              display: inline-block;
              padding: 10px 20px;
              font-weight: 600;
            `}
          >
            New Custom Test
          </div>
        </div>
      )
    } else
      return (
        <OutputOneTab
          analysisOutput={results[criterionKey.toLowerCase()]}
          key={`onetab-${criterionKey}`}
          criterion={criteria[criterionKey]}
          scrollToSource={scrollToSource}
          isShowAllTests={isShowAllTests}
          isShowCategories={isShowCategories}
        />
      )

    // })
  }

  if (!analysisOutput) return null

  return (
    <div className={classes.outputSection}>
      <Hidden xsDown>
        <TabbedView
          tabs={tabNames}
          resultTypes={resultTypes}
          autoScroll
          selectedCriterion={selectedCriterion}
          setSelectedCriterion={function(e) {
            track(consts.MIXPANEL_EVENTS.REVIEW_CATEGORY, {testCategory: tabNames[e]})
            setSelectedCriterion.apply(null, arguments)
          }}
          analysisByCategory={analysisByCategory}
        >
          {generateTabList({
            resultTypes,
            analysisOutput,
            criteria,
            criterionKey,
            results: analysisByCategory,
          })}
        </TabbedView>
      </Hidden>
      <Hidden smUp>
        <OutputTabSelect
          tabs={tabNames}
          autoScroll
          selectedCriterion={selectedCriterion}
          setSelectedCriterion={setSelectedCriterion}
        >
          {generateTabList({
            resultTypes,
            analysisOutput,
            criteria,
            criterionKey,
            results: analysisByCategory,
          })}
        </OutputTabSelect>
      </Hidden>
    </div>
  )
}

OutputComponent = React.memo(OutputComponent)
export default OutputComponent
